var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceLogoCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5V4C15 5.414 15 6.121 15.44 6.56C15.878 7 16.585 7 18 7H19.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11H16M8 14H16M8 17H12.17M4 16V8C4 5.172 4 3.757 4.879 2.879C5.757 2 7.172 2 10 2H14.172C14.58 2 14.785 2 14.969 2.076C15.152 2.152 15.297 2.296 15.586 2.586L19.414 6.414C19.704 6.704 19.848 6.848 19.924 7.032C20 7.215 20 7.42 20 7.828V16C20 18.828 20 20.243 19.121 21.121C18.243 22 16.828 22 14 22H10C7.172 22 5.757 22 4.879 21.121C4 20.243 4 18.828 4 16Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceLogoCurrent);
export default __webpack_public_path__ + "static/media/serviceLogoCurrent.fb9bbd4b11c1cda75c848248ad2db5a6.svg";
export { ForwardRef as ReactComponent };